/* istanbul ignore file */

const tagSearchIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="#006A92">
    <title>Tag Search</title>
    <path
      stroke="none"
      d="M8.458 18.264a.655.655 0 0 1-.486-.216L1.67 11.13a.656.656 0 0 1 .022-.905l8.532-8.532a.656.656 0 0 1 .463-.192h7.22a.656.656 0 0 1 .656.656v6.051a.657.657 0 0 1-1.313 0V2.813H10.96L3.06 10.71l5.882 6.455a.656.656 0 0 1-.485 1.098Z"
    />
    <path
      stroke="none"
      d="M13.531 8.4a1.969 1.969 0 1 1 0-3.938 1.969 1.969 0 0 1 0 3.938Zm0-2.625a.657.657 0 1 0 0 1.313.657.657 0 0 0 0-1.313ZM14.923 19.876a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Zm0-9.188a3.939 3.939 0 1 0 0 7.877 3.939 3.939 0 0 0 0-7.877Z"
    />
    <path
      stroke="none"
      d="M21.846 22.5a.657.657 0 0 1-.465-.192l-3.633-4.012a.656.656 0 0 1 .92-.935l3.641 4.02a.656.656 0 0 1-.463 1.119Z"
    />
  </svg>
);

export default tagSearchIcon;
